import { PogNonCircular } from "@CommonTypes/merchflow/pog/pog";

export const RouteGetMerchflows_merchflowId_S2_s2SolutionId_ =
  "/merchflows/:merchflowId/s2/:s2SolutionId";

export interface ResponseGetMerchflows_merchflowId_S2_s2SolutionId_ {
  s1_user_trigger_id: number;
  template_id: string;
  solution: PogNonCircular;
}

export const RouteGetMerchflows_merchflowId_S2_s2SolutionId_logs =
  "/merchflows/:merchflowId/s2/:s2SolutionId/logs";

export interface ResponseGetMerchflows_merchflowId_S2_s2SolutionId_logs {
  s2_algo_request: unknown | null;
  s2_algo_response: unknown | null;
}
